import wpApiFetch from "@wordpress/api-fetch";
import * as wpI18n from "@wordpress/i18n";

// @ts-expect-error
export const apiFetch = (window.wp && window.wp.apiFetch || wpApiFetch) as typeof wpApiFetch;

// @ts-expect-error
export const i18n = (window.wp && window.wp.i18n || wpI18n) as typeof wpI18n;

apiFetch.use(async function(options, next){
	if(!options.headers) options.headers = {};
	// WARNING: fake autentication clear the session at every call, dunno why
	// so session is not reliable while debugging with this
	if(window.debug_username) options.headers['X-LOCAL-DEBUG-USERNAME'] = window.debug_username;
	return next(options);
});